// extracted by mini-css-extract-plugin
export default {"checkbox":"AdvancedSettingsForm_checkbox__jDgja"};